// reducer.js
import * as types from './types';
//import { HttpGet } from "../../services/apiService";
import dayjs from "dayjs";

const currentDate = new Date().toLocaleDateString("en-US");

const initialState = {
  loadingCircular: false,
  loadingLinear: false,
  activeTab: "dashboard",
  publicReviewRating: 0,
  currentDate: currentDate,
  fromDashboardAction: false,
  byChartDateFeedbackClosed: false,
  byFeedbackDateFeedbackClosed: false,
  fromDashboardActionParams: "",
  alertBoxParams: {
    showAlert: false,
    alertMsg: "",
    alertType: "error",
    className: "",
    buttonText: "OK",
    redirectToLogin: false,
  },
  byChartDateSearchParams: {
    basicFilters: {
      frChartDate: currentDate,
      toChartDate: currentDate,
      toChartDateMax: currentDate,
      fbStatusId: 1,
      fbStatusValue: "Open",
      // fbStatusId: "",
      // fbStatusValue: "All",
    },
    advanceFilter: {
      fbCaseNoId: "",
      fbCaseNoValue: "",
      fbAge: "",
      fbCrewNo: "",
      fbBookingSrc: "",
      fbSource: "",
      fbPnrNo: "",
      fbVehicleNo: "",
      fbCustomerNo: "",
      fbORating: "",
      fbAssignedToId: "",
      fbAssignedToValue: "",
      fbTripCodeId: "",
      fbTripCodeValue: "",
      fbServiceClassId: "",
      fbServiceClassValue: "",
      fbDepotId: "",
      fbDepotValue: "",
      fbLostItemId: "",
      fbLostItemValue: "",
      fbCorporationId: "",
      fbCorporationValue: "",
      fbDivisionId: "",
      fbDivisionValue: "",
    },
    toggleMoreFilter: false,
  },
  byChartDateLists: {
    dataLoaded: false,
    resultDataFlag: 1,
    basicFilterResultData: [],
    advanceFilterResultData: [],
  },
  fbDropDownOptions: {
    // routes: [],
    crewNos: [],
    bookingSources: [],
    feedbackSources: [],
    pnrNos: [],
    busNos: [],
    mobiles: [],
    caseNo: [],
    assignedTo: [
      { id: "", value: "All" },
    ],
    tripCode: [],
    serviceClass: [],
    corporation: [],
    division: [],
    depot: [],

  },
  byFeedbackDateSearchParams: {
    basicFilters: {
      frFeedbackDate: currentDate,
      toFeedbackDate: currentDate,
      toFeedbackDateMax: currentDate,
      fbStatusId: 1,
      fbStatusValue: "Open",
      // fbStatusId: "",
      // fbStatusValue: "All",
    },
    advanceFilter: {
      fbFrChartDate: "",
      fbToChartDate: "",
      fbToChartDateMax: currentDate,
      fbAge: "",
      fbCrewNo: "",
      fbBookingSrc: "",
      fbSource: "",
      fbPnrNo: "",
      fbVehicleNo: "",
      fbCustomerNo: "",
      fbORating: "",
      fbCaseNoId: "",
      fbCaseNoValue: "",

      fbAssignedToId: "",
      fbAssignedToValue: "",
      fbTripCodeId: "",
      fbTripCodeValue: "",
      fbServiceClassId: "",
      fbServiceClassValue: "",
      fbDepotId: "",
      fbDepotValue: "",
      fbLostItemId: '',
      fbLostItemValue: '',
      fbCorporationId: "",
      fbCorporationValue: '',
      fbDivisionId: "",
      fbDivisionValue: '',
    },
    toggleMoreFilter: false,
  },
  byFeedbackDateLists: {
    dataLoaded: false,
    resultDataFlag: 1,
    basicFilterResultData: [],
    advanceFilterResultData: [],
  },
  dropDownOptionsForByFeedbackDate: {
    // routes: [],
    crewNos: [],
    bookingSources: [],
    feedbackSources: [],
    pnrNos: [],
    busNos: [],
    mobiles: [],
    caseNo: [],
    assignedTo: [{ id: "", value: "All" }],
    tripCode: [],
    serviceClass: [],
    depot: [],
    corporation: [],
    division: [],
  },
  dashboardData: {
    dataLoaded: false,
    table: [],
    table2: [],
  },
  dashboardSearchParams: {
    basicFilters: {
      frDate: dayjs().subtract(30, "days").format("YYYY-MM-DD"),
      toDate: currentDate,
      toDateMax: currentDate,
      fbDivisionId: "",
      fbDivisionValue: "",
      fbDepotId: "",
      fbDepotValue: "",
      fbServiceClassId: "",
      fbServiceClassValue: "",
      fbCorporationId: "",
      fbCorporationValue: "",
    },
  },
  fbDropDownOptionsDashboard: {
    division: [],
    depot: [],
    corporation: [],
    serviceClass: [],
    pnrNos: [],
    busNos: [],
    mobiles: [],
  },
  feedbackPage: 0
};

const feedbackReducer = (state = initialState, action) => {

  switch (action.type) {

    case types.SHOW_LOADING_CIRCULAR:
      return {
        ...state,
        loadingCircular: action.payload,
      };

    case types.SHOW_LOADING_LINEAR:
      return {
        ...state,
        loadingLinear: action.payload,
      };

    case types.UPDATE_ALERT_BOX_PARAMS:
      return {
        ...state,
        alertBoxParams: {
          ...state.alertBoxParams,
          showAlert: action.payload.showAlert,
          alertMsg: action.payload.alertMsg || state.alertBoxParams.alertMsg,
          alertType: action.payload.alertType || state.alertBoxParams.alertType,
          redirectToLogin: action.payload.redirectToLogin || state.alertBoxParams.redirectToLogin,
        },
      };

    case types.HANDLE_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
        ...(action.payload !== "chartDate" && state.fromDashboardAction === true ? {
          fromDashboardAction: false,
          byChartDateSearchParams: {
            ...state.byChartDateSearchParams,
            toggleMoreFilter: false,
            basicFilters: {
              frChartDate: currentDate,
              toChartDate: currentDate,
              fbStatusId: "",
              fbStatusValue: "",
            },
            advanceFilter: {
              fbCaseNoId: "",
              fbCaseNoValue: "",
              fbAge: "",
              fbCrewNo: "",
              fbBookingSrc: "",
              fbSource: "",
              fbPnrNo: "",
              fbVehicleNo: "",
              fbCustomerNo: "",
              fbORating: "",
              fbTripCodeId: "",
              fbTripCodeValue: "",
              fbServiceClassId: "",
              fbServiceClassValue: "",
              fbDepotId: "",
              fbDepotValue: "",
              fbLostItemId: '',
              fbLostItemValue: '',
              fbCorporationId: "",
              fbCorporationValue: "",
              fbDivisionId: "",
              fbDivisionValue: "",
            },
          },
          byChartDateLists: {
            ...state.byChartDateLists,
            dataLoaded: false,
            basicFilterResultData: [],
          },
        } : {}),
      };

    case types.HANDLE_PUBLIC_REVIEW_RATING:
      return {
        ...state,
        publicReviewRating: action.payload,
      };
    case types.HANDLE_TOGGLE_MORE_FILTERS:
      return {
        ...state,
        byChartDateSearchParams: {
          ...state.byChartDateSearchParams,
          toggleMoreFilter: action.payload,
        },
      };


    case types.UPDATE_CHART_DATE_BASIC_FILTER: {
      const { payload } = action;
      const newState = { ...state };

      if (payload.frChartDate) {
        newState.byChartDateSearchParams.basicFilters.frChartDate = payload.frChartDate;
        newState.byChartDateSearchParams.basicFilters.toChartDateMax = dayjs(payload.frChartDate)
          .add(90, "days")
          .format("YYYY-MM-DD");
      }

      if (payload.toChartDate) {
        newState.byChartDateSearchParams.basicFilters.toChartDate = payload.toChartDate;
      }

      if (payload.fbStatusId || payload.fbStatusId === "") {
        newState.byChartDateSearchParams.basicFilters.fbStatusId = payload.fbStatusId;
      }

      if (payload.fbStatusValue) {
        newState.byChartDateSearchParams.basicFilters.fbStatusValue = payload.fbStatusValue;
      }

      return newState;
    }
case types.UPDATE_CHART_DATE_ADVANCE_FILTER: {
  const updatedAdvanceFilter = {
    ...state.byChartDateSearchParams.advanceFilter,
  };

  if (action.payload.fbFrChartDate) {
    updatedAdvanceFilter.fbFrChartDate = action.payload.fbFrChartDate;
    updatedAdvanceFilter.fbToChartDateMax = dayjs(action.payload.fbFrChartDate)
      .add(90, "days")
      .format("MM/DD/YYYY");
  }

  if (action.payload.fbToChartDate || action.payload.fbToChartDate === "") {
    updatedAdvanceFilter.fbToChartDate = action.payload.fbToChartDate;
  }

  if (action.payload.fbCaseNoId || action.payload.fbCaseNoId === "") {
    updatedAdvanceFilter.fbCaseNoId = action.payload.fbCaseNoId;
  }

  if (action.payload.fbCaseNoValue || action.payload.fbCaseNoValue === "") {
    updatedAdvanceFilter.fbCaseNoValue = action.payload.fbCaseNoValue;
  }

  if (action.payload.fbAge || action.payload.fbAge === "") {
    updatedAdvanceFilter.fbAge = action.payload.fbAge;
  }

  if (action.payload.fbCrewNo || action.payload.fbCrewNo === "") {
    updatedAdvanceFilter.fbCrewNo = action.payload.fbCrewNo;
  }

  if (action.payload.fbBookingSrc || action.payload.fbBookingSrc === "") {
    updatedAdvanceFilter.fbBookingSrc = action.payload.fbBookingSrc;
  }

  if (action.payload.fbSource || action.payload.fbSource === "") {
    updatedAdvanceFilter.fbSource = action.payload.fbSource;
  }

  if (action.payload.fbPnrNo || action.payload.fbPnrNo === "") {
    updatedAdvanceFilter.fbPnrNo = action.payload.fbPnrNo;
  }

  if (action.payload.fbVehicleNo || action.payload.fbVehicleNo === "") {
    updatedAdvanceFilter.fbVehicleNo = action.payload.fbVehicleNo;
  }

  if (action.payload.fbCustomerNo || action.payload.fbCustomerNo === "") {
    updatedAdvanceFilter.fbCustomerNo = action.payload.fbCustomerNo;
  }

  if (action.payload.fbORating || action.payload.fbORating === "") {
    updatedAdvanceFilter.fbORating = action.payload.fbORating;
  }

  if (action.payload.fbTripCodeId || action.payload.fbTripCodeId === "") {
    updatedAdvanceFilter.fbTripCodeId = action.payload.fbTripCodeId;
  }

  if (action.payload.fbTripCodeValue || action.payload.fbTripCodeValue === "") {
    updatedAdvanceFilter.fbTripCodeValue = action.payload.fbTripCodeValue;
  }

  if (action.payload.fbServiceClassId || action.payload.fbServiceClassId === "") {
    updatedAdvanceFilter.fbServiceClassId = action.payload.fbServiceClassId;
  }

  if (action.payload.fbServiceClassValue || action.payload.fbServiceClassValue === "") {
    updatedAdvanceFilter.fbServiceClassValue = action.payload.fbServiceClassValue;
  }

  if (action.payload.fbDepotId || action.payload.fbDepotId === "") {
    updatedAdvanceFilter.fbDepotId = action.payload.fbDepotId;
  }

  if (action.payload.fbDepotValue || action.payload.fbDepotValue === "") {
    updatedAdvanceFilter.fbDepotValue = action.payload.fbDepotValue;
  }

  if (action.payload.fbAssignedToId || action.payload.fbAssignedToId === "") {
    updatedAdvanceFilter.fbAssignedToId = action.payload.fbAssignedToId;
  }

  if (action.payload.fbAssignedToValue || action.payload.fbAssignedToValue === "") {
    updatedAdvanceFilter.fbAssignedToValue = action.payload.fbAssignedToValue;
  }

  if (action.payload.fbLostItemId || action.payload.fbLostItemId === "") {
    updatedAdvanceFilter.fbLostItemId = action.payload.fbLostItemId;
  }

  if (action.payload.fbLostItemValue || action.payload.fbLostItemValue === "") {
    updatedAdvanceFilter.fbLostItemValue = action.payload.fbLostItemValue;
  }

  if (action.payload.fbCorporationId || action.payload.fbCorporationId === "") {
    updatedAdvanceFilter.fbCorporationId = action.payload.fbCorporationId;
  }

  if (action.payload.fbCorporationValue || action.payload.fbCorporationValue === "") {
    updatedAdvanceFilter.fbCorporationValue = action.payload.fbCorporationValue;
  }

  if (action.payload.fbDivisionId || action.payload.fbDivisionId === "") {
    updatedAdvanceFilter.fbDivisionId = action.payload.fbDivisionId;
  }

  if (action.payload.fbDivisionValue || action.payload.fbDivisionValue === "") {
    updatedAdvanceFilter.fbDivisionValue = action.payload.fbDivisionValue;
  }

  return {
    ...state,
    byChartDateSearchParams: {
      ...state.byChartDateSearchParams,
      advanceFilter: updatedAdvanceFilter,
    },
  };
}

    case types.UPDATE_CHART_DATE_RESULT_DATA_FLAG:
      return {
        ...state,
        byChartDateLists: {
          ...state.byChartDateLists,
          resultDataFlag: action.payload,
        },
      };

    case types.UPDATE_CHART_DATE_DATA_PENDING:
      return {
        ...state,
        loadingCircular: action.payload,
        byChartDateLists: {
          ...state.byChartDateLists,
          dataLoaded: false,
          basicFilterResultData: [],
        },
        byChartDateFeedbackClosed: false,
      };

    case types.UPDATE_CHART_DATE_DATA_SUCCESS:
      return {
        ...state,
        loadingCircular: false,
        byChartDateLists: {
          ...state.byChartDateLists,
          dataLoaded: true,
          basicFilterResultData: action.payload,
        },
        fbDropDownOptions: updateDropDownOptions(state.fbDropDownOptions, action.payload),
      };


    case types.UPDATE_CHART_DATE_DATA_FAILED:
      console.warn("Error Message ->", action.payload);
      return {
        ...state,
        loadingCircular: false,
        byChartDateLists: {
          ...state.byChartDateLists,
          dataLoaded: true,
          basicFilterResultData: []
        }
      };
    case types.UPDATE_CHART_DATE_ADVANCE_FILTER_DATA_PENDING:
      return {
        ...state,
        loadingLinear: true,
        byChartDateLists: {
          ...state.byChartDateLists,
          advanceFilterResultData: []
        }
      };
    case types.UPDATE_CHART_DATE_ADVANCE_FILTER_DATA_SUCCESS:
      return {
        ...state,
        loadingLinear: false,
        byChartDateLists: {
          ...state.byChartDateLists,
          advanceFilterResultData: action.payload
        }
      };

    case types.RESET_CHART_DATE_ADVANCE_FILTER:
      return {
        ...state,
        byChartDateSearchParams: {
          ...state.byChartDateSearchParams,
          advanceFilter: {
            fbCaseNoId: "",
            fbCaseNoValue: "",
            fbAge: "",
            fbCrewNo: "",
            fbBookingSrc: "",
            fbSource: "",
            fbPnrNo: "",
            fbVehicleNo: "",
            fbCustomerNo: "",
            fbORating: "",
            tripCode: "",
            fbTripCodeId: "",
            fbTripCodeValue: "",
            fbServiceClassId: "",
            fbServiceClassValue: "",
            fbDepotId: "",
            fbDepotValue: "",
            fbLostItemId: '',
            fbLostItemValue: '',
            fbCorporationId: "",
            fbCorporationValue: "",
            fbDivisionId: "",
            fbDivisionValue: "",
          }
        },
        byChartDateLists: {
          ...state.byChartDateLists,
          advanceFilterResultData: state.byChartDateLists.basicFilterResultData
        }
      };

    case types.UPDATE_FEEDBACK_DATE_BASIC_FILTER:
      const newState = { ...state };

      if (action.payload.frFeedbackDate) {
        newState.byFeedbackDateSearchParams.basicFilters.frFeedbackDate = action.payload.frFeedbackDate;
        newState.byFeedbackDateSearchParams.basicFilters.toFeedbackDateMax = dayjs(action.payload.frFeedbackDate)
          .add(90, "days")
          .format("MM/DD/YYYY");
      }
      if (action.payload.toFeedbackDate) {
        newState.byFeedbackDateSearchParams.basicFilters.toFeedbackDate = action.payload.toFeedbackDate;
      }
      if (action.payload.fbStatusId || action.payload.fbStatusId === "") {
        newState.byFeedbackDateSearchParams.basicFilters.fbStatusId = action.payload.fbStatusId;
      }
      if (action.payload.fbStatusValue) {
        newState.byFeedbackDateSearchParams.basicFilters.fbStatusValue = action.payload.fbStatusValue;
      }

      return newState;

    case types.HANDLE_FEEDBACK_DATE_TOGGLE_MORE_FILTERS:
      return {
        ...state,
        byFeedbackDateSearchParams: {
          ...state.byFeedbackDateSearchParams,
          toggleMoreFilter: action.payload
        }
      };

    case types.UPDATE_FEEDBACK_DATE_ADVANCE_FILTER:

      const updatedAdvanceFilter = {
        ...state.byFeedbackDateSearchParams.advanceFilter
      };

      if (action.payload.fbFrChartDate) {
        updatedAdvanceFilter.fbFrChartDate = action.payload.fbFrChartDate;
        updatedAdvanceFilter.fbToChartDateMax = dayjs(action.payload.fbFrChartDate)
          .add(90, "days")
          .format("MM/DD/YYYY");
      }

      if (action.payload.fbToChartDate) {
        updatedAdvanceFilter.fbToChartDate = action.payload.fbToChartDate;
      }

      if (action.payload.fbAge || action.payload.fbAge === "") {
        updatedAdvanceFilter.fbAge = action.payload.fbAge;
      }

      if (action.payload.fbCrewNo || action.payload.fbCrewNo === "") {
        updatedAdvanceFilter.fbCrewNo = action.payload.fbCrewNo;
      }

      if (action.payload.fbBookingSrc || action.payload.fbBookingSrc === "") {
        updatedAdvanceFilter.fbBookingSrc = action.payload.fbBookingSrc;
      }

      if (action.payload.fbSource || action.payload.fbSource === "") {
        updatedAdvanceFilter.fbSource = action.payload.fbSource;
      }

      if (action.payload.fbPnrNo || action.payload.fbPnrNo === "") {
        updatedAdvanceFilter.fbPnrNo = action.payload.fbPnrNo;
      }

      if (action.payload.fbVehicleNo || action.payload.fbVehicleNo === "") {
        updatedAdvanceFilter.fbVehicleNo = action.payload.fbVehicleNo;
      }

      if (action.payload.fbCustomerNo || action.payload.fbCustomerNo === "") {
        updatedAdvanceFilter.fbCustomerNo = action.payload.fbCustomerNo;
      }

      if (action.payload.fbORating || action.payload.fbORating === "") {
        updatedAdvanceFilter.fbORating = action.payload.fbORating;
      }

      if (action.payload.fbCaseNoId || action.payload.fbCaseNoId === "") {
        updatedAdvanceFilter.fbCaseNoId = action.payload.fbCaseNoId;
      }

      if (action.payload.fbCaseNoValue || action.payload.fbCaseNoValue === "") {
        updatedAdvanceFilter.fbCaseNoValue = action.payload.fbCaseNoValue;
      }

      if (action.payload.fbTripCodeId || action.payload.fbTripCodeId === "") {
        updatedAdvanceFilter.fbTripCodeId = action.payload.fbTripCodeId;
      }

      if (action.payload.fbTripCodeValue || action.payload.fbTripCodeValue === "") {
        updatedAdvanceFilter.fbTripCodeValue = action.payload.fbTripCodeValue;
      }

      if (action.payload.fbServiceClassId || action.payload.fbServiceClassId === "") {
        updatedAdvanceFilter.fbServiceClassId = action.payload.fbServiceClassId;
      }

      if (action.payload.fbServiceClassValue || action.payload.fbServiceClassValue === "") {
        updatedAdvanceFilter.fbServiceClassValue = action.payload.fbServiceClassValue;
      }

      if (action.payload.fbDepotId || action.payload.fbDepotId === "") {
        updatedAdvanceFilter.fbDepotId = action.payload.fbDepotId;
      }

      if (action.payload.fbDepotValue || action.payload.fbDepotValue === "") {
        updatedAdvanceFilter.fbDepotValue = action.payload.fbDepotValue;
      }

      if (action.payload.fbCorporationId || action.payload.fbCorporationId === "") {
        updatedAdvanceFilter.fbCorporationId = action.payload.fbCorporationId;
      }

      if (action.payload.fbCorporationValue || action.payload.fbCorporationValue === "") {
        updatedAdvanceFilter.fbCorporationValue = action.payload.fbCorporationValue;
      }

      if (action.payload.fbDivisionId || action.payload.fbDivisionId === "") {
        updatedAdvanceFilter.fbDivisionId = action.payload.fbDivisionId;
      }

      if (action.payload.fbDivisionValue || action.payload.fbDivisionValue === "") {
        updatedAdvanceFilter.fbDivisionValue = action.payload.fbDivisionValue;
      }

      if (action.payload.fbAssignedToId || action.payload.fbAssignedToId === "") {
        updatedAdvanceFilter.fbAssignedToId = action.payload.fbAssignedToId;
      }

      if (action.payload.fbAssignedToValue || action.payload.fbAssignedToValue === "") {
        updatedAdvanceFilter.fbAssignedToValue = action.payload.fbAssignedToValue;
      }

      if (action.payload.fbLostItemId || action.payload.fbLostItemId === "") {
        updatedAdvanceFilter.fbLostItemId = action.payload.fbLostItemId;
      }

      if (action.payload.fbLostItemValue || action.payload.fbLostItemValue === "") {
        updatedAdvanceFilter.fbLostItemValue = action.payload.fbLostItemValue;
      }

      return {
        ...state,
        byFeedbackDateSearchParams: {
          ...state.byFeedbackDateSearchParams,
          advanceFilter: updatedAdvanceFilter
        }
      };

    case types.UPDATE_FEEDBACK_DATE_RESULT_DATA_FLAG:
      return {
        ...state,
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          resultDataFlag: action.payload
        }
      };

    case types.UPDATE_FEEDBACK_DATE_DATA_PENDING:
      return {
        ...state,
        loadingCircular: action.payload,
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          dataLoaded: false,
          basicFilterResultData: [],
        },
        byFeedbackDateFeedbackClosed: false,
      };

    case types.UPDATE_FEEDBACK_DATE_DATA_SUCCESS:

      return {
        ...state,
        loadingCircular: false,
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          dataLoaded: true,
          basicFilterResultData: action.payload,
        },
        dropDownOptionsForByFeedbackDate: {
          ...state.dropDownOptionsForByFeedbackDate,
          caseNo: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.caseNo, action.payload, 'FBID'),
          tripCode: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.tripCode, action.payload, 'TripCode'),
          serviceClass: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.serviceClass, action.payload, 'BusType'),
          depot: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.depot, action.payload, 'CompanyName'),
          corporation: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.corporation, action.payload, 'CorporationCode'),
          division: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.division, action.payload, 'DivisionName'),
          // routes: updateRoutesDropdownOptions(state.dropDownOptionsForByFeedbackDate.routes, action.payload),
          crewNos: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.crewNos, action.payload, 'CrewNo'),
          bookingSources: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.bookingSources, action.payload, 'BookingSource'),
          feedbackSources: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.feedbackSources, action.payload, 'FeedbackSource'),
          pnrNos: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.pnrNos, action.payload, 'BookingRefNo'),
          busNos: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.busNos, action.payload, 'VehicleNo'),
          mobiles: updateDropdownOptions2(state.dropDownOptionsForByFeedbackDate.mobiles, action.payload, 'MobileNo'),
        },
      };

    case types.UPDATE_FEEDBACK_DATE_DATA_FAILED:
      console.warn("Error Message ->", action.payload);
      return {
        ...state,
        loadingCircular: false,
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          dataLoaded: true,
          basicFilterResultData: [],
        },
      };

    case types.UPDATE_FEEDBACK_DATE_ADVANCE_FILTER_DATA_PENDING:
      return {
        ...state,
        loadingLinear: true,
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          advanceFilterResultData: [],
        },
      };

    case types.UPDATE_FEEDBACK_DATE_ADVANCE_FILTER_DATA_SUCCESS:
      return {
        ...state,
        loadingLinear: false,
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          advanceFilterResultData: action.payload,
        },
      };

    case types.RESET_FEEDBACK_DATE_ADVANCE_FILTER:
      return {
        ...state,
        byFeedbackDateSearchParams: {
          ...state.byFeedbackDateSearchParams,
          advanceFilter: {
            fbFrChartDate: "",
            fbToChartDate: "",
            fbToChartDateMax: currentDate,
            fbAge: "",
            fbCrewNo: "",
            fbBookingSrc: "",
            fbSource: "",
            fbPnrNo: "",
            fbVehicleNo: "",
            fbCustomerNo: "",
            fbORating: "",
            fbCaseNoId: "",
            fbCaseNoValue: "",
            fbTripCodeId: "",
            fbTripCodeValue: "",
            fbServiceClassId: "",
            fbServiceClassValue: "",
            fbDepotId: "",
            fbDepotValue: "",
            fbLostItemId: '',
            fbLostItemValue: '',
            fbCorporationId: "",
            fbCorporationValue: "",
            fbDivisionId: "",
            fbDivisionValue: "",
          },
        },
        byFeedbackDateLists: {
          ...state.byFeedbackDateLists,
          advanceFilterResultData: state.byFeedbackDateLists.basicFilterResultData,
        },
      };

    case types.HANDLE_DASHBOARD_COUNT_LINKS:
      if (action.payload) {
        let newState = {
          ...state,
          activeTab: 'chartDate',
          fromDashboardAction: true,
          fromDashboardActionParams: action.payload,
          level: action.payload.level, // Capture the level flag
          byChartDateSearchParams: {
            ...state.byChartDateSearchParams,
            basicFilters: {
              // frChartDate: dayjs().subtract(90, 'days').format('YYYY-MM-DD'),
              // toChartDate: dayjs().format('YYYY-MM-DD'),
              frChartDate: dayjs(action?.payload?.MinChartDate).format('YYYY-MM-DD'),
              toChartDate: dayjs(action?.payload?.MaxChartDate).format('YYYY-MM-DD'),
              fbStatusId: null,
              fbStatusValue: '',
            },
          },
        };

        if (action.payload.action === 'Closed') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = 2;
          newState.byChartDateSearchParams.basicFilters.fbStatusValue = action.payload.action;
        }

        if (action.payload.action === 'Open') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = 1;
          newState.byChartDateSearchParams.basicFilters.fbStatusValue = action.payload.action;
        }

        if (action.payload.action === 'All') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = '';
          newState.byChartDateSearchParams.basicFilters.fbStatusValue = action.payload.action;
        }

        if (action.payload.action === '>1W') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = 1;
          newState.byChartDateSearchParams.toggleMoreFilter = true;
          newState.byChartDateSearchParams.advanceFilter.fbAge = 1;
        }

        if (action.payload.action === '1WTo3D') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = 1;
          newState.byChartDateSearchParams.toggleMoreFilter = true;
          newState.byChartDateSearchParams.advanceFilter.fbAge = 2;
        }

        if (action.payload.action === '<3D') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = 1;
          newState.byChartDateSearchParams.toggleMoreFilter = true;
          newState.byChartDateSearchParams.advanceFilter.fbAge = 3;
        }

        if (action.payload.action === 'WithRefund' || action.payload.action === 'WithoutRefund') {
          newState.byChartDateSearchParams.basicFilters.fbStatusId = 2;
          newState.byChartDateSearchParams.basicFilters.fbStatusValue = 'Closed';
        }
        if (action?.payload?.fbLostItemId) {
          newState.byChartDateSearchParams.advanceFilter.fbLostItemId = 'Y';
          newState.byChartDateSearchParams.advanceFilter.fbLostItemValue = 'Yes';
        } else {
          newState.byChartDateSearchParams.advanceFilter.fbLostItemId = '';
          newState.byChartDateSearchParams.advanceFilter.fbLostItemValue = 'All';

        }

        return newState;
      }
      return state;

    case types.UPDATE_DASHBOARD_ACTION:
      return {
        ...state,
        fromDashboardAction: action.payload,
      };

    case types.UPDATE_DASHBOARD_DATA_PENDING:
      return {
        ...state,
        loadingLinear: action.payload,
        dashboardData: {
          ...state.dashboardData,
          dataLoaded: false,
          table: [],
          table2: [],
        },
      };

    case types.UPDATE_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loadingLinear: false,
        dashboardData: {
          ...state.dashboardData,
          dataLoaded: true,
          table: action.payload.table,
          table2: action.payload.table2,
        },
      };

    case types.UPDATE_DASHBOARD_DATA_FAILED:
      console.warn("Error Message ->", action.payload);
      return {
        ...state,
        loadingLinear: false,
        dashboardData: {
          ...state.dashboardData,
          dataLoaded: true,
          table: [],
          table2: [],
        },
      };

    case types.HANDLE_FEEDBACK_CLOSED_SUCCESS:
      if (state.activeTab === "chartDate") {
        return {
          ...state,
          byChartDateFeedbackClosed: true,
        };
      } else if (state.activeTab === "feedbackDate") {
        return {
          ...state,
          byFeedbackDateFeedbackClosed: true,
        };
      }
      return state;

    case types.HANDLE_FEEDBACK_CLOSED_SUCCESS_BEFORE:
      if (state.activeTab === "chartDate") {
        return {
          ...state,
          byChartDateFeedbackClosed: false,
        };
      } else if (state.activeTab === "feedbackDate") {
        return {
          ...state,
          byFeedbackDateFeedbackClosed: false,
        };
      }
      return state;

    case types.UPDATE_DASHBOARD_BASIC_FILTER:
      if (action.payload.fbDivisionId || action.payload.fbDivisionId === "") {
        state.dashboardSearchParams.basicFilters.fbDivisionId = action.payload.fbDivisionId;
      }

      if (action.payload.fbDivisionValue) {
        state.dashboardSearchParams.basicFilters.fbDivisionValue = action.payload.fbDivisionValue;
      }

      if (action.payload.fbDepotId || action.payload.fbDepotId === "") {
        state.dashboardSearchParams.basicFilters.fbDepotId = action.payload.fbDepotId;
      }

      if (action.payload.fbDepotValue || action.payload.fbDepotValue === "") {
        state.dashboardSearchParams.basicFilters.fbDepotValue = action.payload.fbDepotValue;
      }

      if (action.payload.fbServiceClassId || action.payload.fbServiceClassId === "") {
        state.dashboardSearchParams.basicFilters.fbServiceClassId = action.payload.fbServiceClassId;
      }

      if (action.payload.fbServiceClassValue || action.payload.fbServiceClassValue === "") {
        state.dashboardSearchParams.basicFilters.fbServiceClassValue = action.payload.fbServiceClassValue;
      }

      if (action.payload.fbCorporationId || action.payload.fbCorporationId === "") {
        state.dashboardSearchParams.basicFilters.fbCorporationId = action.payload.fbCorporationId;
      }

      if (action.payload.fbCorporationValue || action.payload.fbCorporationValue === "") {
        state.dashboardSearchParams.basicFilters.fbCorporationValue = action.payload.fbCorporationValue;
      }

      if (action.payload.frDate) {
        state.dashboardSearchParams.basicFilters.frDate = action.payload.frDate;
        state.dashboardSearchParams.basicFilters.toDateMax = dayjs(action.payload.frDate)
          .add(90, "days")
          .format("YYYY-MM-DD");
      }

      if (action.payload.toDate) {
        state.dashboardSearchParams.basicFilters.toDate = action.payload.toDate;
      }

      return state;

    case types.UPDATE_DEPOT_DIVISION_DATA_PENDING:
      return {
        ...state,
        loadingLinear: action.payload,
        fbDropDownOptionsDashboard: {
          ...state.fbDropDownOptionsDashboard,
          division: [],
          depot: [],
          corporation: [],
        },
      };


    case types.UPDATE_DEPOT_DIVISION_DATA_SUCCESS:
      const { division, depot, corporation } = action.payload;
      return {
        ...state,
        loadingLinear: false,
        fbDropDownOptionsDashboard: {
          ...state.fbDropDownOptionsDashboard,
          division: [{ id: "", value: 'All' }, ...division],
          depot: [{ id: "", value: 'All' }, ...depot],
          corporation: [{ id: '', value: "All" }, ...corporation]
        },
        dashboardSearchParams: {
          ...state.dashboardSearchParams,
          basicFilters: {
            ...state.dashboardSearchParams.basicFilters,
            fbDivisionId: "", fbDivisionValue: "All", fbDepotId: "", fbDepotValue: "All"
          }
        }
      };

    case types.UPDATE_DEPOT_DIVISION_DATA_FAILED:
      console.warn("Error Message ->", action.payload);
      return {
        ...state,
        loadingLinear: false,
        fbDropDownOptionsDashboard: {
          ...state.fbDropDownOptionsDashboard,
          division: [],
          depot: [],
          corporation: []
        },
      };

    case types.UPDATE_SERVICE_CLASS_DATA_PENDING:
      return {
        ...state,
        loadingLinear: action.payload,
        fbDropDownOptionsDashboard: {
          ...state.fbDropDownOptionsDashboard,
          serviceClass: [],
        },
      };

    case types.UPDATE_SERVICE_CLASS_DATA_SUCCESS:
      return {
        ...state,
        loadingLinear: false,
        fbDropDownOptionsDashboard: {
          ...state.fbDropDownOptionsDashboard,
          serviceClass: [{ id: "", value: 'All' }, ...action.payload.serviceClass],
        },
        dashboardSearchParams: {
          ...state.dashboardSearchParams,
          basicFilters: {
            ...state.dashboardSearchParams.basicFilters,
            fbServiceClassId: "", fbServiceClassValue: "All"
          }
        }
      };

    case types.UPDATE_SERVICE_CLASS_DATA_FAILED:
      console.warn("Error Message ->", action.payload);
      return {
        ...state,
        loadingLinear: false,
        fbDropDownOptionsDashboard: {
          ...state.fbDropDownOptionsDashboard,
          serviceClass: [],
        },
      };
    case types.UPDATE_FEEDBACK_PER_PAGE:
      return {
        ...state,
        feedbackPage: action.payload,
      };
    default:
      return state;
  }

};

// Helper function to update dropdown options
const updateDropDownOptions = (options, data) => {
  const updatedOptions = { ...options };
  if (data.length > 0) {
    data.forEach((fbData) => {
      updateOptionList(updatedOptions.caseNo, fbData.FBID);
      updateOptionList(updatedOptions.corporation, fbData.CorporationCode); // Corporation
      updateOptionList(updatedOptions.division, fbData.DivisionName); // Division
      updateOptionList(updatedOptions.depot, fbData.CompanyName);
      updateOptionList(updatedOptions.serviceClass, fbData.BusType);
      updateOptionList(updatedOptions.tripCode, fbData.TripCode);
      // updateOptionList(updatedOptions.routes, fbData.Route + " " + fbData.TripRoute);
      updateOptionList(updatedOptions.crewNos, fbData.CrewNo);
      updateOptionList(updatedOptions.bookingSources, fbData.BookingSource);
      updateOptionList(updatedOptions.feedbackSources, fbData.FeedbackSource);
      updateOptionList(updatedOptions.pnrNos, fbData.BookingRefNo);
      updateOptionList(updatedOptions.busNos, fbData.VehicleNo);
      updateOptionList(updatedOptions.mobiles, fbData.MobileNo);
    });
  }

  return updatedOptions;
};

// Helper function to update option list
const updateOptionList = (optionList, newValue) => {
  if (optionList.length === 0) {
    optionList.push({ id: "", value: "All" });
  }

  if (!optionList.some((a) => a.value === newValue) && newValue !== "") {
    optionList.push({ id: newValue, value: newValue });
  }
};

// Helper function to update dropdown options
const updateDropdownOptions2 = (existingOptions, data, field) => {
  const newOptions = [...existingOptions];

  if (newOptions.length === 0) {
    newOptions.push({ id: "", value: "All" });
  }

  data.forEach((fbData) => {
    if (fbData[field] !== "" && !newOptions.some((a) => a.value === fbData[field])) {
      newOptions.push({ id: fbData[field], value: fbData[field] });
    }
  });
  return newOptions;
};

// Helper function to update routes dropdown options
const updateRoutesDropdownOptions = (existingOptions, data) => {
  const newOptions = [...existingOptions];

  if (newOptions.length === 0) {
    newOptions.push({ id: "", value: "All" });
  }

  data.forEach((fbData) => {
    if (fbData.Route !== "" && fbData.TripRoute && !newOptions.some((a) => a.value === fbData.Route + " " + fbData.TripRoute)) {
      newOptions.push({ id: fbData.Route + " " + fbData.TripRoute, value: fbData.Route + " " + fbData.TripRoute });
    }
  });
  return newOptions;
};

export default feedbackReducer;
